export function buttonOrder() {
    let insightsButton = $(".insights .container >.button");
    let latestNewsButton = $(".latest-news .container >.button");

    function TitleBottomButton() {
        if ($(".insights .title-holder").find('h2,.h2')) {
            let title = $(".title-holder").find('h2,.h2');
            let titleHeight = title.innerHeight();
            insightsButton.addClass("absolute").css("top", titleHeight);
        }
        if ($(".latest-news .container").find('h2,.h2')) {
            let title = $(".latest-news .container").find('h2,.h2');
            title.addClass("button-bottom");
            let titleHeight = title.innerHeight();
            latestNewsButton.addClass("absolute").css("top", titleHeight);
        }
    }

    window.addEventListener("load", () => {
        if (window.innerWidth >= 1200) {
            TitleBottomButton();
        }
    });
    window.addEventListener("resize", () => {
        if (window.innerWidth >= 1200) {
            TitleBottomButton();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/buttonOrder.js